<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage"
  [partners]="partners">


  <!-- Main Title Section -->
  <div class="page-title-section">
    <h2>Assurance Prévoyance Garantie Accidents de la Vie (GAV)</h2>
  </div>
  
  <div class="content-section">
    <p>
      9 fois sur 10 la victime d'un accident domestique se blesse seule et il n'y a pas de responsable identifié. Sans tiers responsable, il n'y a pas de recours possible contre lui, car en effet, il aurait pu prendre en charge intégralement votre préjudice ! La plupart des dépenses sont à la charge de l'assuré et de sa famille. La fréquence (très élevée) et la gravité des accidents de la vie (très importante) ne sont pas couvertes par la Sécurité Sociale, la complémentaire santé, ou encore le contrat Habitation ou la Responsabilité Civile.
    </p>
    <p>
      Le contrat d'assurance Prévoyance GAV a pour objet de garantir les préjudices résultant d'accidents subis par l'assuré dans le cadre de ses activités de la vie privée (domestiques, scolaires, touristiques, de loisirs ou sportives), agressions, attentats, catastrophes naturelles et technologiques ou accidents médicaux. Ces accidents peuvent entraîner soit une incapacité permanente, soit un décès.
    </p>
    <p>
      Ce contrat vous assure une indemnisation sous réserve de la détermination d'un taux d'incapacité permanente, qui doit être supérieur au seuil fixé au contrat et/ou plus grave un décès.
    </p>
    <p>
      Le produit d'assurance prévoyance, appelé GAV (Garantie Accident de la Vie) conserve le niveau de vie de toute une famille. De graves séquelles peuvent être à l'origine d'importantes difficultés financières et matérielles : perte de revenus, aménagement du domicile ou auto, besoin d'une aide-ménagère à domicile. Le niveau de vie de toute la famille est alors compromis.
    </p>
  </div>

  <div class="content-section">
    <p>
      Le courtier en Assurance <strong>BROKINS</strong> est partenaire de nombreux assureurs, dont un échantillon est affiché ci-dessous : <strong>GENERALI, APRIL, AXA SPVIE, SWISSLIFE, MALAKOFF HUMANIS, ALPTIS, POP SANTE, ASAF & AFPS, HENNER, APIVIA MACIF, AVENIR MUTUELLE, IDENTITE MUTUELLE, UCR, PRAECONIS…</strong>
    </p>
  </div>

  <div class="content-section">
    <h3>Ces préjudices peuvent être de 2 types :</h3>
    
    <h4>Les préjudices personnels :</h4>
    <ul>
      <li>Esthétique.</li>
      <li>Moral.</li>
      <li>D'agrément (par exemple : l'impossibilité de se livrer à son sport préféré).</li>
      <li>Souffrances endurées.</li>
    </ul>

    <h4>Les préjudices économiques :</h4>
    <ul>
      <li>L'indemnisation de la baisse ou de la perte de vos revenus si l'accident nécessite un arrêt de travail ou entraîne un décès.</li>
      <li>Aménagement de votre domicile et/ou de votre véhicule, en cas de handicap.</li>
      <li>Frais d'obsèques.</li>
    </ul>
  </div>

  <div class="content-section">
    <h2 class="purple-title">GARANTIES</h2>
    <p>Il existe une multitude de garanties intégrées soit de manière automatique soit en option dans le produit d'Assurance GAV.</p>
    <p><strong>Souvent inclus d'office :</strong></p>
    
    <h3>GARANTIE INCAPACITÉ PERMANENTE (IPP), prend en charge les préjudices suivants :</h3>
    <ul>
      <li>préjudice physique,</li>
      <li>préjudice économique : Versement d'un capital aux bénéficiaires en cas d'invalidité, mais également le versement d'indemnités journalières à l'assuré pour combler le revenu perdu,</li>
      <li>prévention esthétique,</li>
      <li>préjudice d'agrément,</li>
      <li>souffrances endurées,</li>
      <li>frais d'aménagement du véhicule et du domicile : Prise en charge totale des frais de mise aux normes.</li>
    </ul>

    <h3>GARANTIE EN CAS DE DECES, prend en charge les préjudices suivants :</h3>
    <ul>
      <li>préjudice économique : Versement d'un capital forfaitaire aux bénéficiaires,</li>
      <li>préjudice moral,</li>
      <li>frais d'obsèques : Versement d'un capital en cas de décès pour financer ses obsèques,</li>
    </ul>

    <h3>GARANTIE ASSISTANCE :</h3>
    <ul>
      <li>Assistance vie quotidienne : garde des enfants ou des personnes dépendantes à charge, aide-ménagère, garde d'animaux, frais de TV en cas d'hospitalisation suite à accident…,</li>
      <li>Avance de fonds en cas de décès,</li>
      <li>Assistance renseignement juridique : habitation, logement, impôts, fiscalité, assurances, recours, succession…,</li>
      <li>Maintien à domicile : audit financier, habitat et vie quotidienne pour organiser le maintien à domicile suite à l'invalidité permanente</li>
      <li>Assistance obsèques : rapatriement en cas de décès à l'étranger, conseils formalités administratives…</li>
      <li>Assistance voyages : rapatriement en cas de décès à l'étranger, conseils formalités administratives…</li>
      <li>Assistance psychologique : suite à une invalidité permanente.</li>
      <li>Assistance recherche d'emploi : renseignements sur la conception d'un CV, création d'entreprise, la formation professionnelle…</li>
    </ul>

    <p><strong>Souvent proposées en option :</strong></p>
    <ul>
      <li><strong>FRAIS 1ER EQUIPEMENT EN PROTHÈSE,</strong></li>
      <li><strong>OBSÈQUES :</strong> Versement d'un capital en cas de décès pour financer ses obsèques et éviter une charge financière à sa famille. Mise à disposition d'une assistance complète pour aider sa famille à faire face au décès,</li>
      <li><strong>GARANTIES DU CONDUCTEUR (idéal en complément de l'assurance Auto/Moto) :</strong> Couverture des accidents de la route avec versement d'un capital,</li>
      <li><strong>GARANTIES SPORT A RISQUE :</strong> Couverture des accidents survenus lors de la pratique d'un sport considéré à risques. Exemples : plongée sous-marine, parapente, saut à ski, canyoning, spéléologie, escalade, kitesurf.</li>
    </ul>
  </div>

  <div class="content-section">
    <h2 class="purple-title">EXCLUSIONS</h2>
    <p>
      Pour pouvoir bénéficier de cette assurance, notamment de l'indemnisation qui peut atteindre 1 million d'euros en cas de décès ou d'invalidité, il est nécessaire de ne pas réaliser certaines activités qui sont systématiquement exclues par les assureurs.
    </p>
    <p><strong>Exemples d'activités/sports exclus :</strong> Participation à des compétitions, démonstrations, acrobaties, raids, nécessitant l'utilisation d'engins aériens ainsi que la participation à des vols d'essai, vols sur prototype.</p>
    <p><strong>La pratique à titre amateur ou professionnelle des activités suivantes :</strong></p>
    <p>
      Alpinisme, escalade à plus de 20 mètres, plongée subaquatique à plus de 20 m de profondeur, navigation en solitaire et/ou à plus de 60 miles nautiques des côtes, spéléologie, boxe, catch, full-contact, kick-boxing, saut à l'élastique, rafting, kite-surf, canyoning, hydrospeed, bobsleigh, ski hors-piste, hockey sur glace, saut à ski alpin ou nautique, ski acrobatique ou artistique, jumping, arts martiaux et tous sports de combat, chasse aux bêtes fauves, parachutisme, vol à voile, deltaplane, parapente, compétitions motonautiques, compétitions sur des véhicules terrestres à moteur ; varappe, ou au tremplin, skeleton, canoë-kayak, yachting (le yachting s'entend comme l'utilisation de bateaux de plaisance conçus pour la navigation en haute mer et au large).
    </p>
  </div>

  <div class="content-section">
    <h2 class="purple-title">JUSTIFICATIONS</h2>
    <p>Ne pensez pas que les autres contrats d'assurance en possession peuvent vous couvrir en cas d'accident de la vie.</p>
    
    <h3>Sécurité sociale :</h3>
    <p>
      Le régime obligatoire couvre les frais médicaux (soins, hospitalisation et médicaments) ainsi qu'une partie de la perte de vos revenus pendant un arrêt de travail. Mais il n'indemnise pas le préjudice moral, le préjudice personnel (préjudice esthétique, d'agrément, les souffrances endurées) et les aménagements du domicile principal et/ou du véhicule.
    </p>

    <h3>Assurance Santé :</h3>
    <p>
      Comme la SS, la complémentaire santé complète les remboursements effectués par le régime obligatoire en matière de frais de santé : frais pharmaceutiques, chirurgicaux, d'hospitalisation, honoraires médicaux, prothèses dentaires. Mais il n'indemnise pas le préjudice moral, le préjudice personnel (préjudice esthétique, d'agrément, les souffrances endurées) et les aménagements du domicile principal et/ou du véhicule.
    </p>
    <p>
      Le régime obligatoire et la complémentaire santé ne remboursent jamais les dépenses dues aux conséquences durables d'un accident comme le réaménagement de votre maison suite à un handicap par exemple, ou la perte de vos revenus si vous ne pouvez plus exercer votre activité professionnelle.
    </p>
    <p>En ce qui vous concerne, vous, votre conjoint, votre enfant : voici les accidents les plus fréquents qui peuvent vous arriver.</p>
    <ul>
      <li>De 1 à 4 ans (votre enfant) : intoxications, brûlures, noyades, morsures,</li>
      <li>De 25 à 65 ans (vous 2) : accidents ménagers et de bricolage, route.</li>
    </ul>

    <h3>Assurance Responsabilité Civile Vie privée :</h3>
    <p>Cette assurance ne vous couvre pas, mais les tiers à qui vous causent des préjudices.</p>

    <h3>Assurance Habitation :</h3>
    <p>Il n'y a que des garanties qui protègent vos biens, on appelle cela une assurance dommages matériels.</p>
    <p>
      Les accidents de la vie du quotidien ont souvent lieu au sein de votre habitation. Il est donc très fréquent de souscrire une assurance GAV en complément de l'Assurance Multirisque Habitation dit MRH dont vous trouverez plus d'informations ici.
    </p>
  </div>

  <!-- Devis Button -->
  <div class="devis-button-section">
    <button class="btn-devis-large" (click)="navigateToDevis()">
      Devis en ligne
    </button>
  </div>
</app-page-layout>


